import { render, staticRenderFns } from "./LaptopSpec.vue?vue&type=template&id=4065ed96&"
import script from "./LaptopSpec.vue?vue&type=script&lang=js&"
export * from "./LaptopSpec.vue?vue&type=script&lang=js&"
import style0 from "./LaptopSpec.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports